import kayangSdk from '../kayang-app-sdk'

export default {
    isKayang: true,
    ready() {
        return Promise.resolve()
    },
}
